
export {AnchorDot, CheckedDot, EmptyDot, HalfDot, FilledDot, Arrow};

import {ipx} from './utils.js';

// ---------------------------
// ICONS
// ---------------------------

AnchorDot.ANCHORED_CLR = "#009900";
AnchorDot.RELATIVE_CLR = "#009900";
AnchorDot.EMPTY_CLR    = "#cccccc";
AnchorDot.BEYOND_CLR   = "#ff0000";

AnchorDot.STATE_EMPTY    = 0;
AnchorDot.STATE_RELATIVE = 1;
AnchorDot.STATE_ANCHOR   = 2;
AnchorDot.STATE_BEYOND   = 3;

function AnchorDot() {

	// --------------------------
	// Properties
	// --------------------------

	const dot                 = document.createElement('div');
	dot.className           = "dot16";
	dot.style.borderColor   = AnchorDot.EMPTY_CLR;
	dot.state               = '';

	dot.letter              = document.createElement('div');
	dot.letter.className    = "letter16";


	// --------------------------
	// Methods
	// --------------------------

	dot.anchor = function() {
		dot.state = AnchorDot.STATE_ANCHOR;
		dot.style.borderColor = AnchorDot.ANCHORED_CLR;
		dot.letter.innerHTML = 'S';
	};

	dot.relative = function() {
		dot.state = AnchorDot.STATE_RELATIVE;
		dot.style.borderColor = AnchorDot.RELATIVE_CLR;
		dot.letter.innerHTML = '&bull;';
	};

	dot.empty = function() {
		dot.state = AnchorDot.STATE_EMPTY;
		dot.style.borderColor = AnchorDot.EMPTY_CLR;
		dot.letter.innerHTML = '';
	};

	dot.beyond = function() {
		dot.state = AnchorDot.STATE_BEYOND;
		dot.style.borderColor = AnchorDot.BEYOND_CLR;
		dot.letter.innerHTML = '!';
	};


	// --------------------------
	// Inits
	// --------------------------

	dot.appendChild(dot.letter);


	// --------------------------
	// Return
	// --------------------------

	return dot;
}

function CheckedDot(dot_color, check_color, checked) {

	// --------------------------
	// Properties
	// --------------------------

	const dot                 = document.createElement('div');
	dot.className           = "dot16";
	dot.style.borderColor   = dot_color;
	dot.checked             = checked;

	const check               = document.createElement('div');
	check.className         = "check16";
	check.style.borderColor = check_color;

	// --------------------------
	// Methods
	// --------------------------

	dot.check = function(tf) {
		dot.checked = (tf != undefined) ? tf : true;
		check.style.borderColor = (dot.checked == true) ? check_color : dot_color;
	};

	dot.uncheck = function() {
		dot.check(false);
	};

	// --------------------------
	// Inits
	// --------------------------

	dot.appendChild(check);
	dot.check(checked);

	// --------------------------
	// Return
	// --------------------------

	return dot;
}

function HalfDot(dot_color, maskcolor) {

	const dot               = document.createElement('div');
	dot.className         = "emptydot16";
	dot.style.borderColor = (dot_color != undefined) ? dot_color : "#ff9900";
	dot.style.background  = dot.style.borderColor;

	const mask              = document.createElement('div');
	mask.style.background = maskcolor;
	mask.style.margin     = ipx(0);
	mask.style.padding    = ipx(0);
	mask.style.width      = ipx(14);
	mask.style.height     = ipx(7);
	dot.appendChild(mask);

	return dot;
}

function EmptyDot(dot_color, bgcolor) {

	const dot               = document.createElement('div');
	dot.className         = "emptydot16";
	dot.style.borderColor = (dot_color != undefined) ? dot_color : "#ff9900";
	dot.style.background  = (bgcolor != undefined)   ? bgcolor   : "#ff9900";

	return dot;
}

function FilledDot(bdcolor) {

	const dot = EmptyDot(bdcolor, "transparent");

	dot.set_color = function(c) {
		dot.style.background = c;
	};

	return dot;
}

function Arrow(n, color, direction) {

	const a = document.createElement("div");
	a.style.width    = ipx(0);
	a.style.height   = ipx(0);
	a.style.cssFloat = "left";

	if (direction == "N") {
		a.style.borderLeft   = ipx(n) + " solid transparent";
		a.style.borderRight  = a.style.borderLeft;
		a.style.borderBottom = ipx(n) + " solid " + color;

	} else if (direction == "S") {
		a.style.borderLeft  = ipx(n) + " solid transparent";
		a.style.borderRight = a.style.borderLeft;
		a.style.borderTop   = ipx(n) + " solid " + color;

	} else if (direction == "W") {
		a.style.borderTop    = ipx(n) + " solid transparent";
		a.style.borderBottom = a.style.borderTop;
		a.style.borderRight  = ipx(n) + " solid " + color;

	} else if (direction == "E") {
		a.style.borderTop    = ipx(n) + " solid transparent";
		a.style.borderBottom = a.style.borderTop;
		a.style.borderLeft   = ipx(n) + " solid " + color;
	}

	return a;
}

